var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"showEvents",attrs:{"id":"showEvents","no-close-on-esc":"","ok-only":"","size":"xl"}},[_c('template',{slot:"modal-title"},[_vm._v(_vm._s(_vm.$t('eventLog')))]),_c('b-table',{staticClass:"aco-table",attrs:{"show-empty":"","striped":"","hover":"","items":_vm.events,"fields":_vm.eventFields,"small":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }